import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface OsDistributionProps {
  data: { family: string; count: number }[];
}

const LABELS: Record<string, string> = {
  ios: "iOS",
  ipados: "iPadOS",
  macos: "macOS",
  tvos: "tvOS",
  watchos: "watchOS",
  unknown: "Unknown",
};

export function OsDistribution({ data }: OsDistributionProps) {
  const total = data.reduce((sum, d) => sum + d.count, 0);
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          OS distribution
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {data.length === 0 && (
          <p className="text-xs text-muted-foreground">No devices reporting.</p>
        )}
        {data.map((d) => {
          const pct = total ? Math.round((d.count / total) * 100) : 0;
          return (
            <div key={d.family} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium">{LABELS[d.family] ?? d.family}</span>
                <span className="text-muted-foreground tabular-nums">
                  {d.count} · {pct}%
                </span>
              </div>
              <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full bg-primary"
                  style={{ width: `${pct}%` }}
                  aria-hidden="true"
                />
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}

export default OsDistribution;
